import { handleActions } from 'redux-actions-helpers'
import { InitialState } from './types'
import * as actions from './actions'

const initialState: InitialState = {
  contest: null,
  myWork: null,
  isFetchingContests: false,
  isProcessSendWork: false,
  isProcessUploadFile: false,
  isProcessRemoveFile: false,
  isFetchingMyWork: false,
  lastRemovedFile: '',
  error: '',
}

export default handleActions(
  {
    [actions.fetchContest]: state => {
      return {
        ...state,
        isFetchingContests: true,
        error: initialState.error,
      }
    },
    [actions.fetchContestSuccess]: (state, action) => {
      return {
        ...state,
        contest: action.result,
        isFetchingContests: false,
      }
    },
    [actions.fetchContestFailure]: (state, action) => {
      return {
        ...state,
        isFetchingContests: false,
        error: action.error,
      }
    },
    [actions.sendWork]: state => {
      return {
        ...state,
        isProcessSendWork: true,
        error: initialState.error,
      }
    },
    [actions.sendWorkSuccess]: state => {
      return {
        ...state,
        isProcessSendWork: false,
      }
    },
    [actions.sendWorkFailure]: (state, action) => {
      return {
        ...state,
        isProcessSendWork: false,
        error: action.error,
      }
    },
    [actions.updateWork]: state => {
      return {
        ...state,
        isProcessSendWork: true,
        error: initialState.error,
      }
    },
    [actions.updateWorkSuccess]: state => {
      return {
        ...state,
        isProcessSendWork: false,
      }
    },
    [actions.updateWorkFailure]: (state, action) => {
      return {
        ...state,
        isProcessSendWork: false,
        error: action.error,
      }
    },
    [actions.uploadFile]: state => {
      return {
        ...state,
        isProcessUploadFile: true,
        uploadFileProgress: 0,
        error: initialState.error,
      }
    },
    [actions.uploadFileSuccess]: state => {
      return {
        ...state,
        isProcessUploadFile: false,
      }
    },
    [actions.uploadFileFailure]: (state, action) => {
      return {
        ...state,
        isProcessUploadFile: false,
        error: action.error,
      }
    },
    [actions.removeFile]: state => {
      return {
        ...state,
        isProcessRemoveFile: true,
        error: initialState.error,
      }
    },
    [actions.removeFileSuccess]: (state, action) => {
      return {
        ...state,
        lastRemovedFile: action.file_id,
        isProcessRemoveFile: false,
      }
    },
    [actions.removeFileFailure]: (state, action) => {
      return {
        ...state,
        isProcessRemoveFile: false,
        error: action.error,
      }
    },
    [actions.removeFileFromWork]: state => {
      return {
        ...state,
        isProcessRemoveFile: true,
        error: initialState.error,
      }
    },
    [actions.removeFileFromWorkSuccess]: (state, action) => {
      return {
        ...state,
        lastRemovedFile: action.file_id,
        isProcessRemoveFile: false,
      }
    },
    [actions.removeFileFromWorkFailure]: (state, action) => {
      return {
        ...state,
        isProcessRemoveFile: false,
        error: action.error,
      }
    },
    [actions.fetchMyWork]: state => {
      return {
        ...state,
        isFetchingMyWork: true,
        error: initialState.error,
      }
    },
    [actions.fetchMyWorkSuccess]: (state, action) => {
      return {
        ...state,
        myWork: action.result,
        isFetchingMyWork: false,
      }
    },
    [actions.fetchMyWorkFailure]: (state, action) => {
      return {
        ...state,
        isFetchingMyWork: false,
        error: action.error,
      }
    },
    [actions.destroy]: () => initialState,
  },
  { initialState }
)
